import Vue from 'vue'
import Vuex from 'vuex'


import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'
import * as types from './types'

Vue.use(Vuex)



const state = {
    //hostAPI: 'http://localhost:81/api/',
    hostAPI: 'http://zk.pawelkurdziel.pl/api/',
    logged: false,
    role: "",
    getted_data_0: {},
    getted_data_1: {},
    getted_data_2: {},
    getted_data_3: {},
    getted_data_4: {},
    getted_data_5: {},
    getted_data_6: {},
    getted_data_7: {},
    getted_data_8: {},
}

export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
    types
})